import { styled } from "styled-components";
import { ImageIconProps } from "./types";

export const ImageIcon = styled.img<ImageIconProps>`
  width: ${({ width, size }) => width || size};
  height: ${({ height, size }) => height || size};
`;